export default __webpack_public_path__ + "static/media/google-calendar.582d1127.svg";